import React from 'react'
import { useFileUrl } from './helpers'

const PDFPreview = ({ previewProps: { FileID, HashSum_FileID_ } }) => {
  const fileData = useFileUrl(FileID, HashSum_FileID_)
  const [iframeAttributes, setIframeAttributes] = React.useState({})

  React.useEffect(() => {
    if (fileData.url) {
      setIframeAttributes({
        type: fileData.contentType,
        src: fileData.url,
      })
    }
  }, [fileData])

  if (!iframeAttributes) {
    return null
  }

  return <iframe {...iframeAttributes} className="file-preview__pdf" name="pdf-preview" title="PDF" />
}

export default PDFPreview
